const base = { fill: "none", stroke: "#1C1917", strokeWidth: 1.6, strokeLinecap: "round", strokeLinejoin: "round" };

export function HoodieArt({ className = "", color = "#1C1917" }) {
  return (
    <svg viewBox="0 0 200 240" className={className} role="img" aria-label="Sweat à capuche, logo brodé au cœur">
      <rect width="200" height="240" fill="#F4F0EA" />
      <g {...base} fill={color} stroke={color}>
        <path d="M70 62 C66 36 134 36 130 62 L128 78 L72 78 Z" />
        <path d="M62 72 L30 90 L18 170 L50 176 L54 140 L54 216 L146 216 L146 140 L150 176 L182 170 L170 90 L138 72 Z" />
      </g>
      <g {...base} stroke="#FBF9F5" strokeOpacity=".55">
        <path d="M78 62 C84 50 116 50 122 62" />
        <path d="M78 74 C86 92 114 92 122 74" />
        <path d="M86 92 L88 118 M114 92 L112 118" />
        <path d="M74 166 H126 M74 166 L82 194 H118 L126 166" />
        <path d="M54 208 H146" />
        <path d="M18 170 L50 176 M150 176 L182 170" />
      </g>
      <g stroke="#C25E38" strokeWidth="2.4" fill="none" strokeLinecap="round">
        <path d="M104 100 c5-8 11 3 15-3 s6 5 10-1" />
        <path d="M110 108 l12 0" />
      </g>
    </svg>
  );
}

export function FleeceArt({ className = "", color = "#2B2F3A" }) {
  return (
    <svg viewBox="0 0 200 240" className={className} role="img" aria-label="Veste polaire, logo brodé au cœur">
      <rect width="200" height="240" fill="#F4F0EA" />
      <g {...base} fill={color} stroke={color}>
        <path d="M66 64 L30 84 L18 168 L50 174 L54 136 L54 216 L146 216 L146 136 L150 174 L182 168 L170 84 L134 64 Z" />
      </g>
      <g {...base} stroke="#FBF9F5" strokeOpacity=".6">
        <path d="M66 64 L80 56 L100 70 L120 56 L134 64" />
        <path d="M80 56 L100 70 L120 56 M100 70 V216" />
        <path d="M100 76 V210" strokeDasharray="3 4" />
        <path d="M64 152 H84 M116 152 H136 M64 152 L66 168 H84 M136 152 L134 168 H116" />
        <path d="M54 208 H146" />
        <path d="M18 168 L50 174 M150 174 L182 168" />
      </g>
      <g stroke="#C25E38" strokeWidth="2.4" fill="none" strokeLinecap="round">
        <path d="M114 100 c5-8 11 3 15-3 s6 5 10-1" />
        <path d="M120 108 l12 0" />
      </g>
    </svg>
  );
}

export function StitchDetail({ className = "" }) {
  return (
    <svg viewBox="0 0 200 160" className={className} role="img" aria-label="Détail de broderie au cœur">
      <rect width="200" height="160" fill="#1C1917" />
      <g stroke="#C25E38" strokeWidth="3" fill="none" strokeLinecap="round">
        {[0, 1, 2, 3, 4, 5, 6, 7].map((i) => <path key={i} d={`M${40 + i * 16} 60 c6-18 14 6 20-10`} />)}
        {[0, 1, 2, 3, 4, 5, 6].map((i) => <path key={`b${i}`} d={`M${48 + i * 16} 96 l10 0`} />)}
      </g>
      <g stroke="#FBF9F5" strokeOpacity=".35" strokeWidth="1">
        {[0, 1, 2, 3, 4, 5, 6, 7, 8, 9].map((i) => <path key={`l${i}`} d={`M20 ${20 + i * 13} H180`} />)}
      </g>
    </svg>
  );
}

export const PACK_ART = { hoodie: HoodieArt, fleece: FleeceArt };
